import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=6e685556&scoped=true&lang=html&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=6e685556&lang=scss&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e685556",
  null
  
)

export default component.exports